<toolbar-halls *renderIf="{mediaSelector:'gt-md'}" class="hidden lg:block sticky top-16 lg:top-[120px]"></toolbar-halls>
<div #header class="w-full h-fit">
  <news-header  *renderIf="{mediaSelector:'gt-md'}" class="w-full hidden md:block"></news-header>
  <news-headerResponsive *renderIf="{mediaSelector:'lt-md'}" class="w-full md:hidden"></news-headerResponsive>
</div>


<!-- BANNER 1 -->
@defer (when usersService.userAction()) {
  <carousel-banner
    carouselId="news-carousel"
    class="my-5 h-[102px] w-full"
    adUnit="/21791770962/dfp_exp_news">
  </carousel-banner>
} @placeholder() {
  <div class="my-5 h-[102px] w-full"></div>
}

<!-- CONTENT -->

<content class="container pt-2" #top>
  <div class="flex flex-row justify-between items-end gap-10">
    <div class="w-1/2 gap-5">
      <h3 class="text-4xl" i18n="news companies title">Updates from online exhibitors</h3>
      <h4 class="text-2xl" i18n="news companies subtitle">New products, innovations, and services from industry leaders</h4>
    </div>
    <call-to-action class="hidden md:block" [withHeader]="false" [blackHeader]="true"></call-to-action>
  </div>

  <div class="flex flex-row pt-[45px] items-start justify-between max-h-full box-border" [style.height]="totalSize + 'px'">
    <filters ngSkipHydration 
      *renderIf="{mediaSelector:'gt-lg'}"
      class="hidden lg:flex w-[370px] top-[160px]"
      [$filters]="treeDataSource"
      (selectionChange)="filterNews($event)">
    </filters>
    <div class="flex flex-grow lg:mx-5 min-w-full lg:min-w-[600px] xl:min-w-[525px] 2xl:min-w-[calc(100%-725px)]">

    <paged-virtual-scroller #psNews
      class="flex w-full"
      [scrollWithMainScrollbar]="true"
      [enableUnequalChildrenSizes]="false"
      [itemTpl]="newsTpl"
      [pageSize]="8"
      seoFriendly="offset-cursor"
      [itemsQuery]="newsQuery">
    </paged-virtual-scroller>

    <ng-template let-item let-index="index" #newsTpl>
      <news-block-social
        class="max-w-full w-full h-auto md:max-w-[824px] md:h-auto mb-5 flex place-content-center"
        itemListId="portal_news"
        itemListName="Portal News Page"
        [newsItem]="item">
      </news-block-social>
    </ng-template>
    </div>
    <div *renderIf="{mediaSelector:'gt-xl'}" class="hidden xl:block sticky top-[150px] w-[325px] h-[740px]">
      <paged-virtual-scroller
        class="flex h-full"
        [itemTpl]="eventsTpl"
        [itemWidth]="325"
        [itemHeight]="240"
        [pageSize]="6"
        [itemsQuery]="eventsQuery"
        [wrapInScrollbar]="true">
      </paged-virtual-scroller>

      <ng-template let-item let-index="index" #eventsTpl>
        <event-block
          class="w-[325px] h-[240px]"
          [portalEvent]="item"
          [imageSizes]="[{ w: 325, h: 183, resizeMode: 'fill' }]">
        </event-block>
      </ng-template>
    </div>
  </div>
</content>
